import { Component, OnInit, Inject } from '@angular/core';
import { FADE_IN } from '../../../../util/animations/animation';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { HelperService } from '../../../../util/helper/helper.service';

/**
 * This component is used to show the custom inputs (questions) for templatesglobal.fetch = require('node-fetch');
 * 
 * The Questions can be configured in backend and based on the type we show the input fields and validations
 */
@Component({
  selector: 'app-custom-template-input',
  templateUrl: './custom-template-input.component.html',
  styleUrls: ['./custom-template-input.component.scss'],
  animations: [ FADE_IN ]
})
export class CustomTemplateInputComponent implements OnInit {

  allQuestions: any = [];
  questionNumber = 0;
  activeQuestion:any = {};
  questionForm: FormGroup;
  progress = 0;

  constructor(public dialogRef: MatDialogRef<CustomTemplateInputComponent>,
    @Inject(MAT_DIALOG_DATA) public popupData,
    private FB: FormBuilder,
    private helper: HelperService) { 
      this.allQuestions = this.popupData.questions;
    }

  ngOnInit(): void {
    this.travelQuestions(this.questionNumber);
  }

  generateDashboardForm(data){
    this.questionForm = this.FB.group({
      field: [data, this.setValidations()]
    })
  }

  /**
   * This function is used to set the validation by reading the object from popup data
   */
  setValidations(){
    const validation = [];
    const data = this.activeQuestion.validations;
    if(data.required)
      validation.push(Validators.required);
    if(data.email)
      validation.push(Validators.email);
    if(data.minLength)
      validation.push(Validators.minLength(data.minLength))
    if(data.maxLength)
      validation.push(Validators.maxLength(data.maxLength))
    if(data.pattern)
      validation.push(Validators.pattern(data.pattern));
    return validation;
  }

  /**
   * This function is use to travel the questions in forward direction
   */
  nextQuestion() {
    if(this.questionNumber < this.allQuestions.length-1) {
      this.travelQuestions(++this.questionNumber);
    }else{
      this.dialogRef.close({questions: this.allQuestions});
    }
  }

   /**
   * This function is use to travel the questions in backword direction
   */
  previousQuestion() {
    if (this.questionNumber>0) 
      this.travelQuestions(--this.questionNumber);
  }

  /**
   * This function is used to change the display questions
   * @param index 
   */
  travelQuestions(index){
    this.activeQuestion = this.allQuestions[index];
    let data:any = '';
    if(this.activeQuestion.type === 'date' || this.activeQuestion.type === 'date_time')
      data = this.activeQuestion.answer? new Date(this.activeQuestion.answer) : new Date()
    else if(this.activeQuestion.answer)
      data = this.activeQuestion.answer
    this.setProgress();
    this.generateDashboardForm(data);
  }

  /**
   * This function calculates how many questions have been answered and what is the completed percentage
   */
  setProgress(){
    const count = this.popupData.rowQuestions.filter(x=> x.answer).length;
    this.progress = (100/this.popupData.rowQuestions.length) * count
  }

  onClosePopup(){
    this.dialogRef.close();
  }

  /**
   * This function gets called after answering the question 
   */
  onSubmit(){
    if(this.questionForm.valid){
      let data = this.questionForm.value.field;
      if(this.activeQuestion.type === 'date' || this.activeQuestion.type === 'date_time')
        data = this.helper.dateFormat(data, this.allQuestions[this.questionNumber].format);
      this.allQuestions[this.questionNumber].answer = data;
      this.activeQuestion = {};
      setTimeout(x=>{
        this.nextQuestion();
      },0)
    }
  }
}
